import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

console.log('[Supabase] URL:', supabaseUrl ? 'Set' : 'Missing')
console.log('[Supabase] Key:', supabaseAnonKey ? 'Set' : 'Missing')

// Only create client if we have valid credentials
let supabase: SupabaseClient | null = null

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
  console.log('[Supabase] Client created successfully')
} else {
  console.error('[Supabase] Missing credentials!')
}

export { supabase }
